var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.522,
    height: 24.499,
    viewBox: "0 0 24.522 24.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1421",
    "data-name": "Group 1421",
    transform: "translate(0.502 0.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_15",
    "data-name": "Union 15",
    d: "M11777.009,16189.412a11.811,11.811,0,0,1,10.259-11.072c.468-.053.943-.085,1.419-.094a.892.892,0,0,1,.96.891.878.878,0,0,1-.931.87,9.984,9.984,0,0,0-.793,19.934c.194.016.395.032.472.036a10.045,10.045,0,0,0,10.353-9.653c.036-.829.35-1.236.927-1.208s.862.452.846,1.281a11.812,11.812,0,0,1-10.255,11.264,12.5,12.5,0,0,1-1.457.085A11.753,11.753,0,0,1,11777.009,16189.412Zm10.048,4.282q-2-2.159-3.981-4.322c-.094-.1-.19-.2-.276-.31a.879.879,0,0,1,.065-1.207.856.856,0,0,1,1.236.028c.463.463.9.959,1.346,1.443.829.9,1.659,1.8,2.537,2.753,1.265-1.277,2.48-2.509,3.7-3.733q3.318-3.312,6.637-6.615a3.548,3.548,0,0,1,.37-.346.865.865,0,0,1,1.167.085.886.886,0,0,1,.068,1.139,2.712,2.712,0,0,1-.28.3q-5.429,5.417-10.861,10.833a.984.984,0,0,1-1.728-.049Z",
    transform: "translate(-11777 -16178.248)",
    fill: "#2d335d",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundTick);
export default __webpack_public_path__ + "static/media/round-tick.495b1a7677e46bbf0ab7b635343aa657.svg";
export { ForwardRef as ReactComponent };